<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">Cards</div>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <!--Card with Image-->
                <div class="cards-container">
                    <div class="title">Card with Image</div>
                    <div class="col-4">
                        <div class="cards-block">
                            <div class="card">
                                <img class="card-img-top" src="static/images/cardsimg.jpg" alt="Card with Image">
                                <div class="card-body">
                                    <h5 class="card-title">Card title</h5>
                                    <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                                    <a href="#" class="btn btn-primary">Read More</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="cards-block">
                            <div class="card">
                                <img class="card-img-top" src="static/images/cardsimg.jpg" alt="Card with Image">
                                <div class="card-body">
                                    <h5 class="card-title">Card title</h5>
                                    <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                                    <a href="#" class="btn btn-primary">Read More</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="cards-block">
                            <div class="card">
                                <img class="card-img-top" src="static/images/cardsimg.jpg" alt="Card with Image">
                                <div class="card-body">
                                    <h5 class="card-title">Card title</h5>
                                    <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                                    <a href="#" class="btn btn-primary">Read More</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--Card with Image-->
                <div class="height70">&nbsp;</div>
                <!--Text Alignment-->
                <div class="cards-container">
                    <div class="title">Text alignment</div>
                    <div class="col-4 text-alignment-left">
                        <div class="cards-block">
                            <b-card title="Left align"
                                    img-alt="Image"
                                    img-top
                                    tag="article"
                                    style="max-width: 20rem;"
                                    class="mb-2">
                                <p class="card-text">
                                    Some quick example text to build on the card title and make up the bulk of the card's content.
                                </p>
                                <b-button href="#" variant="primary">Read More</b-button>
                            </b-card>
                        </div>
                    </div>
                    <div class="col-4 text-alignment-center">
                        <div class="cards-block">
                            <b-card title="Center align"
                                    img-alt="Image"
                                    img-top
                                    tag="article"
                                    style="max-width: 20rem;"
                                    class="mb-2">
                                <p class="card-text">
                                    Some quick example text to build on the card title and make up the bulk of the card's content.
                                </p>
                                <b-button href="#" variant="primary">Read More</b-button>
                            </b-card>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="cards-block text-alignment-right">
                            <b-card title="Right align"
                                    img-alt="Image"
                                    img-top
                                    tag="article"
                                    style="max-width: 20rem;"
                                    class="mb-2">
                                <p class="card-text">
                                    Some quick example text to build on the card title and make up the bulk of the card's content.
                                </p>
                                <b-button href="#" variant="primary">Read More</b-button>
                            </b-card>
                        </div>
                    </div>
                </div>
                <!--Text Alignment-->
                <div class="height70">&nbsp;</div>
                <!--Card styles-->
                <div class="cards-container">
                    <div class="title">Card styles</div>
                    <div class="col-6 text-alignment-left">
                        <div class="card">
                            <div class="card-header card-header1">
                                Card Title
                            </div>
                            <div class="card-body">
                                <p class="card-text">With supporting text below as a natural lead-in to additional content.</p>
                                <a href="#" class="btn btn-primary">Primary</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-6 text-alignment-left">
                        <div class="card">
                            <div class="card-header card-header2">
                                Card Title
                            </div>
                            <div class="card-body">
                                <p class="card-text">With supporting text below as a natural lead-in to additional content.</p>
                                <a href="#" class="btn btn-primary">Primary</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-6 text-alignment-left">
                        <div class="card">
                            <div class="card-header card-header3">
                                Card Title
                            </div>
                            <div class="card-body">
                                <p class="card-text">With supporting text below as a natural lead-in to additional content.</p>
                                <a href="#" class="btn btn-primary">Primary</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-6 text-alignment-left">
                        <div class="card">
                            <div class="card-header card-header4">
                                Card Title
                            </div>
                            <div class="card-body">
                                <p class="card-text">With supporting text below as a natural lead-in to additional content.</p>
                                <a href="#" class="btn btn-primary">Primary</a>
                            </div>
                        </div>
                    </div>
                </div>
                <!--Card styles-->
                <div class="height70">&nbsp;</div>
                <!--Card with Deck-->
                <div class="cards-container">
                    <div class="title">Card with Image</div>
                    <div class="col-4">
                        <div class="cards-block">
                            <div class="card">
                                <img class="card-img-top" src="static/images/card-with-deck1.jpg" alt="Card with Deck">
                                <div class="card-body">
                                    <h5 class="card-title">Card title</h5>
                                    <p class="card-text">This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit </p>
                                    <small>Last updated 3 mins ago</small>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="cards-block">
                            <div class="card">
                                <img class="card-img-top" src="static/images/card-with-deck1.jpg" alt="Card with Deck">
                                <div class="card-body">
                                    <h5 class="card-title">Card title</h5>
                                    <p class="card-text">This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit </p>
                                    <small>Last updated 3 mins ago</small>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="cards-block">
                            <div class="card">
                                <img class="card-img-top" src="static/images/card-with-deck1.jpg" alt="Card with Deck">
                                <div class="card-body">
                                    <h5 class="card-title">Card title</h5>
                                    <p class="card-text">This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit </p>
                                    <small>Last updated 3 mins ago</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--Card with Deck-->
            </div>
            <!--page content-->
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>
<script>
    import Vue from 'vue';
    import BackendFooter from '@/components/backend/partials/footer';

    import { Card } from 'bootstrap-vue/es/components';
    export default {
        name: 'Center',
        components: {
            'app-backend-footer': BackendFooter,

        },
        data() {
            return {
                dismissSecs: 10,
                dismissCountDown: 0,
                showDismissibleAlert: false
            }

        },
        beforeMount: function () {

        },
        mounted: function () {

        },
        methods: {
            countDownChanged(dismissCountDown) {
                this.dismissCountDown = dismissCountDown
            },
            showAlert() {
                this.dismissCountDown = this.dismissSecs
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/components/cards.vue